import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetEdit } from '../../../../shared/components/widget-edit/widget-edit';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { ModalService } from '../../../../shared/services/modal.service';

@Component({
  selector: 'app-savings-goal-widget',
  standalone: true,
  imports: [CommonModule, WidgetEdit, CdkOverlayOrigin],
  templateUrl: './savings-goal.html',
  styleUrls: ['./savings-goal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SavingsGoal {
  @Input() title = 'Savings Plans';
  @Input() size: 'small' | 'medium' | 'half' | 'full' = 'medium';
  @Input() index = 0;
  @Input() isEditMode = false;
  @Input() isAddMode = false;
  @Output() addWidget = new EventEmitter<void>();
  @Input() activeDropdownIndex: number | null = null;
  @Input() getAvailableSizes!: (index: number) => Array<{ value: string; label: string }>;
  @Input() toggleSizeDropdown!: (index: number, event: Event) => void;
  @Input() changeWidgetSize!: (index: number, size: any) => void;
  @Input() removeWidget!: (index: number) => void;

  constructor(private modalService: ModalService) { }

  openModal() {
    if (!this.isEditMode && !this.isAddMode) {
      this.modalService.openSavingPlansModal();
    }
  }
}